<template>
  <div></div>
</template>

<script>
import { getOpenId } from "@/api/bapi";
import { weixinLogin } from "@/api/bapi";

import { constants } from "fs";
export default {
  name: "BindWeChat",
  data() {
    return {
      code: "",
      url: "",
      openId: ""
    };
  },
  watch: {
    $route(to, from) {
      if (to.from.indexOf("LoginWeChat") > 0) {
        this.code = "";
        this.bind();
      }
    }
  },
  created() {
    this.code = "";
    this.$nextTick(() => {
      let vue = this;
      window.setTimeout(function() {
        vue.bind();
      }, 500);
    });
  },
  methods: {
    hq() {
      let vue = this;
      this.$axios({
        method: "get",
        url: "portal/webchat/getopnid/" + this.code
      })
        .then(res => {
          if (res.data.code == 0) {
            this.openId = res.data.data.openId;
            this.login();
          } else {
            alert("授权失效");
          }
        })
        .catch(err => {
          alert(err);
        });
    },
    login() {
      let that = this;
      weixinLogin(this.openId)
        .then(res => {
          if (res.status == 200) {
            localStorage.setItem("access_token", res.data.access_token);
            localStorage.setItem("refresh_token", res.data.refresh_token);
            localStorage.setItem("token_type", res.data.token_type);
            this.$axios({
              headers: {
                Authorization:
                  localStorage.getItem("token_type") +
                  localStorage.getItem("access_token")
              },
              method: "get",
              url: "admin/user/loginInfo"
            })
              .then(res => {
                if (res.status == 200) {
                  if (res.data.code == 0) {
                    if (!res.data.data.org) {
                      alert("登录失败，请确认您的账号为企业帐号");
                        that.$router.back();
                    } else if (res.data.data.org.instituteForm == 2) {
                      alert("登录失败，请确认您的账号为企业帐号");
                        that.$router.back();
                    } else {
                      that.$Message.success("登录成功");
                      localStorage.setItem(
                        "loginUserInfo",
                        JSON.stringify(res.data.data)
                      );
                      console.log(localStorage.getItem("loginUserInfo"));
                      that.$router.push("/index");
                    }
                  } else {
                    that.$Message.error(res.data.msg);
                      setTimeout(() => {
                        that.$router.back();
                      }, 1000);
                  }
                } else {
                  that.$message.error("网络错误，请稍候再试");
                  that.$router.back();
                }
              })
              .catch(err => {
                that.$message.error("你目前没有平台权限");
                this.$router.back();
              });
          } else {
            this.$Messages.error(res.data.msg);
            this.$router.back();
          }
        })
        .catch(err => {
          alert("该微信未绑定帐号，请先使用账号密码登录，绑定帐号。");
            that.$router.push("/");
        });
    },
    bind() {
      this.code = this.$route.query.code;
      this.url = window.location.href;
      let c = this.url.substr(
        this.url.indexOf("=") + 1,
        this.url.indexOf("&") - 1 - this.url.indexOf("=")
      );
      this.hq();
    }
  }
};
</script>

<style scoped>
.img_content {
  display: flex;
  margin: 10px 0;
  justify-content: space-around;
}
.store p {
  width: 30%;
}
.store p img {
  width: 100%;
}
.list {
  padding-bottom: 60px;
  margin-top: 10px;
}
.left_img {
  width: 30%;
}
.left_img img {
  width: 100%;
}
.list_content {
  display: flex;
  padding: 5px;
  margin-top: 10px;
  box-shadow: 0px 0px 3px #ece6e6;
}
.title {
  width: 70%;
  text-align: left;
}
h4 {
  font-size: 1rem;
  margin-top: 1.3rem;
  color: #2c3e50;
  margin-left: 1rem;
}
.sub {
  font-size: 0.8rem;
  margin-top: 1.3rem;
  color: red;
  margin-left: 1rem;
}
.more {
  float: right;
  color: #b8b8b8;
  font-size: 0.8rem;
}
.look {
  float: right;
  color: #45b035;
}
.it {
  font-size: 0.6rem;
  margin: 5px 0;
  margin-left: 1rem;
}
.img_content img {
  border-radius: 6px;
}
.ej {
  position: absolute;
  width: 100%;
  background-color: #45b035;
  left: 0;
  top: 38px;
  z-index: 100;
  text-align: right;
}
.ej li {
  width: 100%;
  text-align: center;
  color: white;
  border-bottom: 1px solid #fff;
}

.ej li a {
  width: 100%;
  text-align: center;
  color: white;
}
.ej li a:hover {
  color: white;
}
</style>
<style lang="scss" scoped>
.introduce {
  text-align: left;
  font-size: 0.8rem;
  color: #999999;
  background-color: white;
  padding: 0.8rem;
}
.introduce p {
  margin-bottom: 0.5rem;
}
.silde-box {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginWeChat.vue